import { Suspense, forwardRef, lazy } from "react";
import {
  RICH_TEXT_TOOLBAR,
  richTextBodyClass,
  richTextBoxClass,
} from "@/components/RichTextEditor/box";
import type {
  InlineImage,
  InlineImagePreviewer,
  InlineImageUploader,
  RichTextEditorProps,
} from "@/components/RichTextEditor/props";

const Impl = lazy(() =>
  import("@/components/RichTextEditor/RichTextEditorImpl").then((m) => ({
    default: m.RichTextEditor,
  })),
);

export type {
  InlineImage,
  InlineImagePreviewer,
  InlineImageUploader,
  RichTextEditorProps,
};

export const RichTextEditor = forwardRef<HTMLDivElement, RichTextEditorProps>(
  function RichTextEditor(props, forwardedRef) {
    return (
      <Suspense fallback={<Placeholder {...props} />}>
        <Impl ref={forwardedRef} {...props} />
      </Suspense>
    );
  },
);

function Placeholder({ value, compact, invalid, disabled, className }: RichTextEditorProps) {
  return (
    <div className={richTextBoxClass({ invalid, disabled, className })} aria-busy="true">
      <div className={RICH_TEXT_TOOLBAR}>
        <div className="h-8" />
      </div>
      <div className={richTextBodyClass({ compact })}>
        <p className="rich-text min-w-0 flex-auto whitespace-pre-wrap px-3 py-2 text-slate-400">
          {value}
        </p>
      </div>
    </div>
  );
}
